function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getOpenedPanelMapForDashboard, LayoutUtils } from '@deephaven/dashboard';
import Log from '@deephaven/log';
import { getFilterSetsForDashboard, getInputFiltersForDashboard, getTableMapForDashboard, setDashboardFilterSets as setDashboardFilterSetsAction } from "../redux/index.js";
import Panel from "./CorePanel.js";
import FilterSetManager from "./FilterSetManager.js";
import { IrisGridPanel } from "./IrisGridPanel.js";
import DropdownFilterPanel from "./DropdownFilterPanel.js";
import InputFilterPanel from "./InputFilterPanel.js";
import "./FilterSetManagerPanel.css";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('FilterSetManagerPanel');
function hasSetPanelState(panel) {
  return panel.setPanelState != null;
}
export class FilterSetManagerPanel extends Component {
  static changeFilterIndexesToColumnNames(table, configs) {
    return configs.map(_ref => {
      var _ref2 = _slicedToArray(_ref, 2),
        index = _ref2[0],
        filter = _ref2[1];
      if (index >= table.columns.length) {
        return null;
      }
      var name = table.columns[index].name;
      return {
        name,
        filter
      };
    }).filter(config => config != null);
  }
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleFilterApply = this.handleFilterApply.bind(this);
    this.handleSetsUpdate = this.handleSetsUpdate.bind(this);
    this.handleGetFilterState = this.handleGetFilterState.bind(this);
    var panelState = props.panelState,
      filterSets = props.filterSets;
    var _ref3 = panelState !== null && panelState !== void 0 ? panelState : {},
      _ref3$selectedId = _ref3.selectedId,
      selectedId = _ref3$selectedId === void 0 ? filterSets.length > 0 ? filterSets[0].id : undefined : _ref3$selectedId,
      _ref3$isValueShown = _ref3.isValueShown,
      isValueShown = _ref3$isValueShown === void 0 ? false : _ref3$isValueShown;
    this.state = {
      selectedId,
      isValueShown,
      // eslint-disable-next-line react/no-unused-state
      panelState // Dehydrated panel state that can load this panel
    };
  }

  // Collect all filter values for each dashboard panel
  getFilterState() {
    var dashboardOpenedPanelMap = this.props.dashboardOpenedPanelMap;
    var panels = [];
    [...dashboardOpenedPanelMap.keys()].forEach(key => {
      var panel = dashboardOpenedPanelMap.get(key);
      if (panel === undefined) {
        log.error('Could not get panel', panel);
        return;
      }
      var componentName = LayoutUtils.getComponentNameFromPanel(panel);
      var panelId = LayoutUtils.getIdFromPanel(panel);
      log.debug('Panel:', panel, componentName);
      var _panel$props$glContai = panel.props.glContainer,
        glContainer = _panel$props$glContai === void 0 ? null : _panel$props$glContai;
      if (glContainer == null) {
        log.error('Could not get panel container', panel);
        return;
      }
      var config = LayoutUtils.getComponentConfigFromContainer(glContainer);
      if (config == null) {
        log.error('Could not get component config from container', glContainer);
        return;
      }
      var panelState = LayoutUtils.getPanelComponentState(config);
      if (panelState == null) {
        log.debug("Panel state is null ".concat(panelId));
        return;
      }
      switch (componentName) {
        case LayoutUtils.getComponentName(IrisGridPanel):
          {
            var state;
            if (panelId != null) {
              state = this.getIrisGridPanelFilters(panelId, panelState);
            }
            if (state != null) {
              panels.push({
                panelId,
                type: componentName,
                state
              });
            }
            break;
          }
        case LayoutUtils.getComponentName(InputFilterPanel):
        case LayoutUtils.getComponentName(DropdownFilterPanel):
          {
            var isValueShown = panelState.isValueShown,
              name = panelState.name,
              type = panelState.type,
              value = panelState.value;
            panels.push({
              panelId,
              type: componentName,
              state: {
                isValueShown,
                name,
                type,
                value
              }
            });
            break;
          }
        default:
      }
    });
    return panels;
  }
  getIrisGridPanelFilters(panelId, panelState) {
    var panelTableMap = this.props.panelTableMap;
    var table = panelTableMap.get(panelId);
    if (table == null) {
      log.error("Unable to get table for panel ".concat(panelId, "."));
      return null;
    }
    // IrisGridUtils.hydrate uses numeric indexes for columns
    // Change indexes to column names to make it work for proxy models
    var _panelState$irisGridS = panelState.irisGridState,
      irisGridState = _panelState$irisGridS === void 0 ? {
        advancedFilters: undefined,
        quickFilters: undefined
      } : _panelState$irisGridS,
      _panelState$gridState = panelState.gridState,
      gridState = _panelState$gridState === void 0 ? {} : _panelState$gridState;
    var indexedAdvancedFilters = irisGridState.advancedFilters,
      indexedQuickFilters = irisGridState.quickFilters;
    var advancedFilters;
    if (indexedAdvancedFilters) {
      advancedFilters = FilterSetManagerPanel.changeFilterIndexesToColumnNames(table, indexedAdvancedFilters);
    }
    var quickFilters;
    if (indexedQuickFilters) {
      quickFilters = FilterSetManagerPanel.changeFilterIndexesToColumnNames(table, indexedQuickFilters);
    }
    return {
      irisGridState: _objectSpread(_objectSpread({}, irisGridState), {}, {
        advancedFilters,
        quickFilters
      }),
      gridState: _objectSpread({}, gridState)
    };
  }
  handleGetFilterState() {
    return this.getFilterState();
  }
  handleChange(_ref4) {
    var isValueShown = _ref4.isValueShown,
      selectedId = _ref4.selectedId;
    log.debug('handleChange', isValueShown, selectedId);
    this.setState({
      isValueShown,
      selectedId
    });
    this.updatePanelState();
  }
  handleFilterApply(filterSet) {
    var dashboardOpenedPanelMap = this.props.dashboardOpenedPanelMap;
    var panels = filterSet.panels,
      _filterSet$restoreFul = filterSet.restoreFullState,
      restoreFullState = _filterSet$restoreFul === void 0 ? false : _filterSet$restoreFul;
    log.debug("Apply filters from filter set", filterSet);
    panels.forEach(_ref5 => {
      var panelId = _ref5.panelId,
        type = _ref5.type,
        state = _ref5.state;
      if (panelId == null) {
        log.debug('panel is null', panelId);
        return;
      }
      if (!dashboardOpenedPanelMap.has(panelId)) {
        log.debug('Ignore closed panel', panelId);
        return;
      }
      log.debug('Apply panel filters', panelId, type, state);
      var panel = dashboardOpenedPanelMap.get(panelId);
      switch (type) {
        case LayoutUtils.getComponentName(IrisGridPanel):
          this.restoreIrisGridFilters(panel, state, restoreFullState);
          break;
        case LayoutUtils.getComponentName(InputFilterPanel):
        case LayoutUtils.getComponentName(DropdownFilterPanel):
          this.restoreInputFilterState(panel, state);
          break;
        default:
      }
    });
  }
  handleSetsUpdate(modifiedFilterSets) {
    var _this$props = this.props,
      setDashboardFilterSets = _this$props.setDashboardFilterSets,
      localDashboardId = _this$props.localDashboardId;
    log.debug('Saving updated sets', modifiedFilterSets);
    // Filter sets are stored in dashboard data instead of the panelState
    // because they need to be shared between the filter view manager panels
    setDashboardFilterSets(localDashboardId, [...modifiedFilterSets]);
  }
  updatePanelState() {
    this.setState(_ref6 => {
      var selectedId = _ref6.selectedId,
        isValueShown = _ref6.isValueShown;
      return {
        // eslint-disable-next-line react/no-unused-state
        panelState: {
          selectedId,
          isValueShown
        }
      };
    });
  }
  restoreIrisGridFilters(panel, state, restoreFullState) {
    // Fall back to state.advancedFilters and state.quickFilters
    // for backward compatibility with filter sets that only contain filters
    var _state$irisGridState = state.irisGridState,
      irisGridState = _state$irisGridState === void 0 ? {} : _state$irisGridState,
      _state$advancedFilter = state.advancedFilters,
      prevAdvancedFilters = _state$advancedFilter === void 0 ? [] : _state$advancedFilter,
      _state$quickFilters = state.quickFilters,
      prevQuickFilters = _state$quickFilters === void 0 ? [] : _state$quickFilters;
    var _irisGridState$advanc = irisGridState.advancedFilters,
      advancedFilters = _irisGridState$advanc === void 0 ? prevAdvancedFilters : _irisGridState$advanc,
      _irisGridState$quickF = irisGridState.quickFilters,
      quickFilters = _irisGridState$quickF === void 0 ? prevQuickFilters : _irisGridState$quickF;
    var panelTableMap = this.props.panelTableMap;
    var panelId = LayoutUtils.getIdFromPanel(panel);
    if (panelId == null) {
      log.error("Panel Id is null.");
      return;
    }
    var table = panelTableMap.get(panelId);
    if (table == null) {
      log.error("Unable to get table for panel ".concat(panelId, "."));
      return;
    }
    log.debug('restoreIrisGridFilters', panelId, state, restoreFullState);
    if (restoreFullState) {
      panel.setStateOverrides(state);
    } else {
      panel.setFilters({
        quickFilters: quickFilters,
        advancedFilters: advancedFilters
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  restoreInputFilterState(panel, state) {
    var inputFilterState = _objectSpread({}, state);
    // Restore state but don't flip the card
    delete inputFilterState.isValueShown;
    log.debug('restoreInputFilterState', panel, inputFilterState);
    if (panel && hasSetPanelState(panel)) {
      panel.setPanelState(inputFilterState);
    }
  }
  render() {
    var _this$props2 = this.props,
      glContainer = _this$props2.glContainer,
      glEventHub = _this$props2.glEventHub,
      filterSets = _this$props2.filterSets;
    var _this$state = this.state,
      isValueShown = _this$state.isValueShown,
      selectedId = _this$state.selectedId;
    return /*#__PURE__*/_jsx(Panel, {
      className: "filter-set-manager-panel",
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      isClonable: true,
      isRenamable: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "input-filter-container h-100 w-100 container",
        children: /*#__PURE__*/_jsx(FilterSetManager, {
          onChange: this.handleChange,
          onApply: this.handleFilterApply,
          onUpdateSets: this.handleSetsUpdate,
          isValueShown: isValueShown,
          filterSets: filterSets,
          selectedId: selectedId,
          getFilterState: this.handleGetFilterState
        })
      })
    });
  }
}
_defineProperty(FilterSetManagerPanel, "defaultProps", {
  panelState: null
});
_defineProperty(FilterSetManagerPanel, "COMPONENT", 'FilterSetManagerPanel');
var mapStateToProps = (state, ownProps) => {
  var localDashboardId = ownProps.localDashboardId;
  return {
    filterSets: getFilterSetsForDashboard(state, localDashboardId),
    dashboardOpenedPanelMap: getOpenedPanelMapForDashboard(state, localDashboardId),
    dashboardInputFilters: getInputFiltersForDashboard(state, localDashboardId),
    panelTableMap: getTableMapForDashboard(state, localDashboardId)
  };
};
var ConnectedFilterSetManagerPanel = connect(mapStateToProps, {
  setDashboardFilterSets: setDashboardFilterSetsAction
}, null, {
  forwardRef: true
})(FilterSetManagerPanel);
export default ConnectedFilterSetManagerPanel;
//# sourceMappingURL=FilterSetManagerPanel.js.map